import { Component } from "react";
import Chart from "react-apexcharts";
// disregard minus signs below; they are an artifact of the visualization library used

class Barchart18 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        {
          name: "Indifferent",
          data: [-10, -8, -11, -15, -17, -26]
        },
        {
          name: "Not Important (No Need)",
          data: [11, 34, 49, 31, 29, 11]
        },
        {
          name: "Important (Nice to Have)",
          data: [54, 53, 55, 60, 61, 53]
        },
        {
          name: "Very Important (Must Have)",
          data: [61, 40, 19, 29, 28, 44]
        }
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          fontFamily: "Lato, Helvetica, Arial, sans-serif"
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            horizontal: true
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return Math.abs(val);
          }
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
          formatter: function (val) {
            return Math.abs(val);
          }
        },
        title: {
          text: "Attitudes Towards Security",
          align: "center"
        },
        xaxis: {
          categories: [
            "Command line interface (CLI)",
            "Install + configure in less than 60 seconds",
            "Graphical user interface (GUI)",
            "Ability to generate customizable reports",
            "IDE integration",
            "CI/CD integration"
          ],
          labels: {
            show: false
          }
        },
        colors: ["#808080", "#fdae61", "#a6d96a", "#1a9641"],
        tooltip: {
          y: {
            formatter: function (val) {
              return Math.abs((val / 136) * 100).toFixed(1) + "%";
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40
        }
      }
    };
  }

  render() {
    return (
      <div className="mixed-chart">
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          width="100%"
          height="500px"
        />
      </div>
    );
  }
}

export default Barchart18;
